import { GUARDIAN_URL_TEMPLATE } from '@/constants';
import { NetworkSettingsConfig, NetworkEnum } from './config.types';
import { CONFIG_MAP, overrideConfigEnv } from './config.utils';
import { memoize } from 'lodash';

// "NEXT_PUBLIC_ALLOW_CONFIG_OVERRIDE" must be set to "true" in .env to enable overriding.
const isConfigOverrideAllowed = process.env.NEXT_PUBLIC_ALLOW_CONFIG_OVERRIDE === 'true';

function interpolateGuardianUrl(template: string, network: NetworkEnum, number: string) {
  return template.replace('{network}', network).replace('{num}', number);
}

function getConfigFn(network: NetworkEnum): NetworkSettingsConfig & { isDev: boolean } {
  const config = CONFIG_MAP[network];
  const networkConfig = isConfigOverrideAllowed ? overrideConfigEnv(config, network) : config;
  const guardians = Array(4)
    .fill(0)
    .map((_, i) => ({
      guardianUrl: interpolateGuardianUrl(GUARDIAN_URL_TEMPLATE, network, (i + 1).toString()),
    }));

  const resultConfig = {
    ...networkConfig,
    isDev: process.env.NEXT_PUBLIC_NODE_ENV === 'development',
    guardians,
  };

  return resultConfig;
}

export const getConfig = memoize(getConfigFn);
